import React from "react";
import { useState } from "react";
import { KaininkasEditor } from "./KaininkasEditor.jsx";

export function KainininkasBigView({ kainininkai, setKainininkai }) {
          const [activeKId, setActiveKId] = useState(null);
          const [showNewK, setShowNewK] = useState(false);
          const [newKName, setNewKName] = useState('');

          const activeK = kainininkai.find(k => k.id === activeKId) || kainininkai[0] || null;

          function addKainininkas() {
            if (!newKName.trim()) return;
            const nk = { id: Date.now(), name: newKName.trim(), groups: [] };
            setKainininkai(prev => [...prev, nk]);
            setActiveKId(nk.id);
            setNewKName(''); setShowNewK(false);
          }
          function delKainininkas(id) {
            if (!window.confirm('Ištrinti kainininką?')) return;
            setKainininkai(prev => prev.filter(k => k.id !== id));
            if (activeKId === id) setActiveKId(null);
          }
          function renameKainininkas(id, name) {
            setKainininkai(prev => prev.map(k => k.id === id ? {...k, name} : k));
          }
          function setKGroups(kId, val) {
            setKainininkai(prev => prev.map(k => {
              if (k.id !== kId) return k;
              const cur = k.groups || [];
              const v = typeof val === 'function' ? val(cur) : val;
              return {...k, groups: v};
            }));
          }
          function setKManufacturers(kId, val) {
            setKainininkai(prev => prev.map(k => {
              if (k.id !== kId) return k;
              const cur = k.manufacturers || [];
              const v = typeof val === 'function' ? val(cur) : val;
              return {...k, manufacturers: v};
            }));
          }

          return (
            <div style={{display:'flex',height:'calc(100vh - 120px)',gap:0,background:'#f5f6fa'}}>
              {/* Kairė: kainininkai sąrašas */}
              <div style={{width:220,background:'#fff',borderRight:'1px solid #e5e7eb',display:'flex',flexDirection:'column',flexShrink:0}}>
                <div style={{padding:'12px 12px 8px',borderBottom:'1px solid #f0f0f0',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <span style={{fontSize:12,fontWeight:800,color:'#1c1c1c'}}>💰 KAINININKAI</span>
                  <button onClick={() => setShowNewK(v=>!v)}
                    style={{background:'#735DFF',color:'#fff',border:'none',borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700,cursor:'pointer'}}>+</button>
                </div>
                {showNewK && (
                  <div style={{padding:'8px 10px',borderBottom:'1px solid #f0f0f0',background:'#fff8f6'}}>
                    <input autoFocus value={newKName} onChange={e=>setNewKName(e.target.value)}
                      onKeyDown={e=>{if(e.key==='Enter')addKainininkas();if(e.key==='Escape'){setShowNewK(false);setNewKName('');}}}
                      placeholder="Kainininko pavadinimas..."
                      style={{width:'100%',border:'1px solid #e5e7eb',borderRadius:5,padding:'5px 7px',fontSize:12,boxSizing:'border-box',marginBottom:5}}/>
                    <div style={{display:'flex',gap:5}}>
                      <button onClick={addKainininkas} style={{flex:1,background:'#735DFF',color:'#fff',border:'none',borderRadius:5,padding:'4px',fontSize:11,fontWeight:700,cursor:'pointer'}}>Sukurti</button>
                      <button onClick={()=>{setShowNewK(false);setNewKName('');}} style={{background:'#f3f4f6',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,cursor:'pointer'}}>✕</button>
                    </div>
                  </div>
                )}
                <div style={{flex:1,overflowY:'auto',padding:'4px 0'}}>
                  {kainininkai.length === 0 && <div style={{padding:'20px 12px',fontSize:11,color:'#9ca3af',textAlign:'center'}}>Nėra kaininkų.<br/>Sukurkite pirmą.</div>}
                  {kainininkai.map(k => (
                    <div key={k.id}
                      style={{display:'flex',alignItems:'center',gap:4,padding:'7px 10px',cursor:'pointer',borderRadius:5,margin:'1px 4px',
                        background:activeK&&activeK.id===k.id?'#fff8f6':'transparent',
                        borderLeft:'3px solid '+(activeK&&activeK.id===k.id?'#735DFF':'transparent')}}
                      onClick={()=>setActiveKId(k.id)}>
                      <span style={{flex:1,fontSize:12,fontWeight:600,color:'#1c1c1c',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{k.name}</span>
                      <span style={{fontSize:10,color:'#9ca3af',flexShrink:0}}>{(k.groups||[]).reduce((a,g)=>a+(g.items||[]).length,0)} poz.</span>
                      <button onClick={e=>{e.stopPropagation();delKainininkas(k.id);}}
                        style={{background:'none',border:'none',color:'#d1d5db',cursor:'pointer',fontSize:14,padding:'0 2px',flexShrink:0}}>×</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Dešinė: aktyvaus kainininko turinys */}
              <div style={{flex:1,overflowY:'auto',padding:'12px'}}>
                {!activeK ? (
                  <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',flexDirection:'column',gap:12,color:'#9ca3af'}}>
                    <div style={{fontSize:40}}>💰</div>
                    <div style={{fontSize:14,fontWeight:600}}>Pasirinkite arba sukurkite kainininką</div>
                  </div>
                ) : (
                  <KaininkasEditor kainininkas={activeK}
                    setGroups={val => setKGroups(activeK.id, val)}
                    onRename={name=>renameKainininkas(activeK.id, name)}
                    setManufacturers={val => setKManufacturers(activeK.id, val)} />
                )}
              </div>
            </div>
          );
        }
